import { selectTheme, styled as newStyled } from '@creditas-ui/react'
import { styled } from '@creditas/stylitas'
import { Typography } from '@creditas/typography'
import React from 'react'

export const LayoutWrapper = styled.section`
  display: flex;
  padding: 20px;

  @media screen and(min-width: 768px) {
    padding: 0;
  }
`

export const LeadsListWrapper = styled.div`
  @media screen and (min-width: 980px) {
    padding: 64px 100px 0;
  }
`

export const Hero = styled.div`
  display: grid;
  grid-template-columns: auto 184px;
  align-items: center;

  @media screen and (min-width: 980px) {
    margin-bottom: 50px;
  }
`

export const Title = styled(Typography)`
  font-weight: 300;
`

export const StepWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const SpacingSection = styled.div`
  padding: 60px 0 10px;

  @media screen and (min-width: 980px) {
    padding: 60px 100px 10px;
  }
`

export const Step = newStyled(Typography)`
  color: ${selectTheme('colors.neutral.80')};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`

export const NewProposalTitle = styled.h1`
  color: ${({ theme }) => theme.bColorNeutral90};
  font-weight: 300;
  font-size: 32px;
  line-height: 48px;
  padding: 0 7vw;
  margin-bottom: 45px;

  @media screen and (min-width: 1300px) {
    margin-bottom: 64px;
  }
`
